import React from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import PropTypes from 'prop-types';

function MailchimpForm({
  children,
  className,
  handleSubmit,
  name = 'subscriber_form',
  setIsSubmitting,
  setMessage,
}) {
  const onSubmit = (data, event) => {
    event.preventDefault();

    setIsSubmitting(true);

    addToMailchimp(data.email_address)
      .then(({ msg, result }) => {
        if (result !== 'success') {
          throw msg;
        }
        setMessage(msg);
      })
      .catch((err) => {
        setMessage(err);
        setIsSubmitting(false);
      });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={className}
      method="POST"
      name={name}
    >
      {children}
    </form>
  );
}

MailchimpForm.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  name: PropTypes.string,
  setIsSubmitting: PropTypes.func.isRequired,
  setMessage: PropTypes.func.isRequired,
};

export { MailchimpForm };
